import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'rentalDuration',
  standalone: true,
})
export class RentalDurationPipe implements PipeTransform {
  transform(pickupDate: string | Date, dropoffDate: string | Date): string {
    if (!pickupDate || !dropoffDate) {
      return '';
    }

    const START = new Date(pickupDate);
    const END = new Date(dropoffDate);

    const DIFF_MS = END.getTime() - START.getTime();
    if (DIFF_MS <= 0) {
      return '0 hours';
    }

    const TOTAL_MINUTES = DIFF_MS / (1000 * 60);
    const TOTAL_HOURS = TOTAL_MINUTES / 60;
    const TOTAL_DAYS = TOTAL_HOURS / 24;

    // CalENDar-based month/year difference
    let years = END.getFullYear() - START.getFullYear();
    let months = END.getMonth() - START.getMonth();
    if (END.getDate() < START.getDate()) {
      months -= 1;
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }

    // ✅ Show only ONE most significant unit (rounded up)
    if (years >= 1) {
      return `${years} year${years > 1 ? 's' : ''}`;
    } else if (months >= 1) {
      return `${months} month${months > 1 ? 's' : ''}`;
    } else if (TOTAL_DAYS >= 1) {
      const DAYS = Math.ceil(TOTAL_DAYS); // round up partial day
      return `${DAYS} day${DAYS > 1 ? 's' : ''}`;
    } else {
      const HOURS = Math.ceil(TOTAL_HOURS); // round up for short durations
      return `${HOURS} hour${HOURS > 1 ? 's' : ''}`;
    }
  }
}
